var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.818 4.818l6.364 6.364M4.818 11.182l6.364-6.364",
    stroke: "#fff",
    strokeWidth: 1.4
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMS4xZW0iIGhlaWdodD0iMS4xZW0iIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC44Ij4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBkPSJNNC44MTc4NyA0LjgxNzk5TDExLjE4MTggMTEuMTgyIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNCIvPgo8cGF0aCBkPSJNNC44MTc4NyAxMS4xODJMMTEuMTgxOCA0LjgxODA1IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNCIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgClear as ReactComponent };